import styled from "styled-components";

export const AdvantagesWorkongSection = styled.section`
  .advantages-section__content {
    flex-wrap: wrap;
    min-height: 27.5rem;
    height: 100%;
    margin-top: 3.75rem;
  }

  .left__side {
    width: 65.5%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 1.25rem;
    height: 31.188rem;
    overflow: hidden;
  }

  .right__side {
    width: 33%;
    height: 100%;
    height: 31.188rem;

    & div {
      height: 100%;
    }
  }

  @media (max-width: 998px) {
    .left__side {
      width: 100%;
      height: auto;
      & div {
        height: auto !important;
      }
    }
    .right__side {
      width: 100%;
      margin-top: 1.25rem;
      height: auto;
    }
    .advantages-section__content {
      flex-direction: column;
    }
  }

  @media (max-width: 601px) {
    .left__side {
      & div {
        width: 100% !important;
      }
    }
  }
`;

export const TradersSection = styled.section`
  background: #001b48;
  color: #fff;

  .big__text {
    margin-top: 1.25rem;
  }

  .main__container {
    margin-top: 3.75rem;
    .top {
      & div:first-child {
        width: 66%;
        background-color: #071330ed;
      }
      & div:last-child {
        width: 34%;
        background-color: #4c5a5f96;
      }
    }
    .bottom {
      & div:first-child {
        width: 34%;
        background-color: #4c5a5f96;
        height: 19.375rem;
      }
      & div:last-child {
        width: 66%;
        background-color: #071330ed;
      }
    }

    .card__settings {
      & div {
        padding: 3.75rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 19.375rem;
      }

      & h2 {
        margin: 1.875rem 0rem;
      }
      & p {
        margin: 1.875rem 0rem;
      }
    }
  }

  @media (max-width: 768px) {
    .main__container {
      .top {
        flex-direction: column;
        & div {
          width: 100% !important;
          height: 13rem;
        }
      }
      .bottom {
        flex-direction: column-reverse;
        & div {
          width: 100% !important;
          height: 13rem;
        }
      }
      .card__settings {
        & div {
          padding: 1.75rem;
        }
      }
    }
  }
`;
